var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 480,
    width: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#399408",
    d: "M2.426 0h637.557v480H2.426z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.167 0C-.67.073 619.765 241.48 619.765 241.48L-.005 479.77.166 0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.28 20.186c3.462 0 559.053 217.89 555.893 220.03L1.867 463.266.287 20.186z",
    fill: "#ffde08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.863.783c1.848 0 290.94 240.92 290.94 240.92L1.863 476.983V.783z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.28 33.902c1.658-14.986 260.9 208.4 260.9 208.4L.268 451.702V33.912z",
    fill: "#de2110"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGy);
export default __webpack_public_path__ + "static/media/gy.9d09c46333e25b4846d839cd2cd58142.svg";
export { ForwardRef as ReactComponent };